import Context from '../SnowplowContext.js'

export const component = new Context('iglu:com.credible.frontend.contexts/component/jsonschema/1-0-0'),
  dashboard = new Context('iglu:com.credible.frontend.contexts/dashboard/jsonschema/1-0-0'),
  product = new Context('iglu:com.credible.frontend.contexts/product/jsonschema/1-0-0'),
  submission = new Context('iglu:com.credible.frontend.contexts/submission/jsonschema/1-0-0'),
  vertical = new Context('iglu:com.credible.frontend.contexts/vertical/jsonschema/1-0-0'),
  partnersWidget = new Context('iglu:com.credible.frontend.contexts/partners_widget/jsonschema/1-0-3'),
  experiment = new Context('iglu:com.credible.frontend.contexts/experiment/jsonschema/1-0-0'),
  ancillaryRevenueProduct = new Context('iglu:com.credible.frontend.contexts/ancillary_revenue_product/jsonschema/1-0-0')
